import Yup from 'utils/yup'

export const defaultValues = {
  name: null,
}

export const validationSchema = Yup.object().shape({
  name: Yup.string().nullable().required().max(60, 'O nome deve ter no máximo 60 caracteres'),
})
